import React from 'react';
import { extractUrlHostname } from '../../../utils';
import { ErrorBoundary } from '../error-boundary';
var Card = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_.smart-card" */'@atlaskit/smart-card').then(function (_ref) {
    var Card = _ref.Card;
    return {
      default: Card
    };
  });
});
var resolveUrlPlaceholder = function resolveUrlPlaceholder(url) {
  var textFragmentRegex = new RegExp('#:~:text=.*$', 'g');
  var urlWithoutTextFragment = url === null || url === void 0 ? void 0 : url.replace(textFragmentRegex, '');
  var maxLength = 30;
  var truncatedUrl = urlWithoutTextFragment.length > maxLength ? urlWithoutTextFragment.slice(0, maxLength) + '...' : urlWithoutTextFragment;
  return truncatedUrl;
};
var fallbackComponent = function fallbackComponent(_ref2) {
  var index = _ref2.index,
    source = _ref2.source,
    searchSessionId = _ref2.searchSessionId,
    onClickHandler = _ref2.onClickHandler;
  return function () {
    var _source$title;
    return /*#__PURE__*/React.createElement("a", {
      href: "".concat(source.url, "?search_id=").concat(searchSessionId),
      onClick: function onClick(e) {
        return onClickHandler(index, extractUrlHostname(source.url));
      },
      rel: "noopener noreferrer",
      target: "_blank"
    }, (_source$title = source.title) !== null && _source$title !== void 0 ? _source$title : source.url);
  };
};
export var SourceCard = function SourceCard(_ref3) {
  var index = _ref3.index,
    source = _ref3.source,
    searchSessionId = _ref3.searchSessionId,
    onClickHandler = _ref3.onClickHandler,
    enableSmartLinkSources = _ref3.enableSmartLinkSources;
  var SmartLinkSource = /*#__PURE__*/React.createElement(Card, {
    appearance: "inline",
    url: source.url,
    removeTextHighlightingFromTitle: true,
    showHoverPreview: true,
    fallbackComponent: fallbackComponent({
      index: index,
      source: source,
      searchSessionId: searchSessionId,
      onClickHandler: onClickHandler
    }),
    onClick: function onClick(e) {
      onClickHandler(index, extractUrlHostname(source.url));
      e.preventDefault();
      window.open("".concat(source.url, "?search_id=").concat(searchSessionId), '_blank', 'noopener, noreferrer');
    },
    onError: function onError() {
      // Nothing for now
    },
    resolvingPlaceholder: resolveUrlPlaceholder(source.url),
    placeholder: resolveUrlPlaceholder(source.url)
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, enableSmartLinkSources ? SmartLinkSource : fallbackComponent({
    index: index,
    source: source,
    searchSessionId: searchSessionId,
    onClickHandler: onClickHandler
  })());
};